import { apiCall } from '../util';
import { storeFeatureFlags } from '../utils/featureFlags.utils';
import {
  FEATURE_FLAGS_FAILED,
  FEATURE_FLAGS_LOADED,
  FEATURE_FLAGS_REQUESTED,
} from './types';

export function getFeatureFlags() {
  return async (dispatch) => {
    try {
      dispatch({ type: FEATURE_FLAGS_REQUESTED });
      const response = await apiCall('customer/FeatureFlag');
      const payload = await response.json();
      const ebFlags = Object.entries(payload)
        .filter(([key]) => key.startsWith('QuoteSites')
          || key.startsWith('QuoteSiteEB')
          || key.startsWith('CrossApp'))
        .reduce((p, [k, v]) => ({ ...p, [k]: v }), {});
      dispatch({ payload: ebFlags, type: FEATURE_FLAGS_LOADED });
      storeFeatureFlags(ebFlags);
    } catch (error) {
      dispatch({ payload: error, type: FEATURE_FLAGS_FAILED });
    }
  };
}
